"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const event_1 = require("../../type/event");
const getBaseEvent_1 = require("./getBaseEvent");
function getSubscribeForIltUpdatesEvent(command, contentType, user) {
    const baseEvent = getBaseEvent_1.getBaseEvent(command);
    const { companyId } = user;
    const { rootContentId, userId } = command;
    return Object.assign({}, baseEvent, { type: event_1.EventType.SUBSCRIBE_FOR_ILT_UPDATES, attributes: {
            contentId: rootContentId,
            userId,
            companyId,
            contentType
        } });
}
exports.getSubscribeForIltUpdatesEvent = getSubscribeForIltUpdatesEvent;
//# sourceMappingURL=getSubscribeForIltUpdatesEvent.js.map